module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMEM0LjQ3IDAgMCA0LjQ3IDAgMTBzNC40NyAxMCAxMCAxMCAxMC00LjQ3IDEwLTEwUzE1LjUzIDAgMTAgMHptMCAxOGMtNC40MiAwLTgtMy41OC04LThzMy41OC04IDgtOCA4IDMuNTggOCA4LTMuNTggOC04IDh6IiBmaWxsPSIjQzlDOUM5Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./assets/svgs/gray-circle.svg
// module id = 1609
// module chunks = 0